// Constantes applicatives
// ========================

'use strict';

var constantes = {
  _PASS: 40524,
  _YEAR: 2019
};

var listTmi =  [
      {value: '0.0',label: '0.0 %'},
      // {value : '0.055',label : '5.50 %'},
      {value: '0.14',label: '14.0 %'},
      {value: '0.30',label: '30.0 %'},
      {value: '0.41',label: '41.0 %'},
      {value: '0.45',label: '45.0 %'}
      ];

module.exports = {
  constantes: constantes,
  listTmi: listTmi
};